<template>
  <div>
    <v-row>
      <v-spacer></v-spacer>
      <v-col class="text-right">
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">Assign or Remove Offices</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                    <v-col cols="12" class="text-center">
                        </v-col>
                        <v-col cols="6" lg="4" offset-lg="2">Added</v-col>
                        <v-col cols="6" lg="4" >Not Added</v-col>
                        <v-col cols="6" lg="4" offset-lg="2" class="user-box">
                        <ul v-for="office in getAssignedGroupOffices" :key="office.id">
                            <li @dblclick="remove(office)">{{ office.name }} </li>
                        </ul>
                        </v-col>
                        <v-col cols="6" lg="4" class="user-box">
                        <ul v-for="office in getUnassignedGroupOffices" :key="office.id">
                            <li @dblclick="add(office)">{{ office.name }}</li>
                        </ul>
                    </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close()">Close</v-btn>
              <v-btn color="blue darken-1" text @click="save()">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Swal from 'sweetalert2';

export default {
    name: 'AssignOfficeModule',
    props: {
        dialog: Boolean,
        selectedOffice: Object
    },
    data () {
        return {
            assigned_offices: [],
        }
    },
    methods: {
        ...mapActions(['fetchUnassignedGroupOffices', 'groupAddOffice', 'groupRemoveOffice', 'saveGroupOfficeAssignment']),
        close() {
            this.$emit('closeDialog', false);
        },
        add(item) {
          this.groupAddOffice(item);
        },
        remove(item) {
          this.groupRemoveOffice(item);
        },
        async save() {
          const save = await this.saveGroupOfficeAssignment();
          if(save.error) {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Internal Server Error',
            })
          } else {
            Swal.fire(
              'Saved!',
              'Positions have been updated',
              'success'
            )
            this.close();
          }
        }
    },
    computed: mapGetters(['getAssignedGroupOffices', 'getUnassignedGroupOffices']),
    watch: {
        selectedOffice: function () {
          if(this.selectedOffice) {
            const body = { id: this.selectedOffice.id, offices: this.selectedOffice.offices};
            this.fetchUnassignedGroupOffices(body);
          }
        }
    }
}
</script>

<style scoped>
  .user-box {
    overflow: auto;
    overflow-x:hidden;
    height: 300px;
    border-style: solid;
    border-width: thin;
    border-color: #d1d1d1;
  }

  ul {
    padding: 0px;
    margin-top: 0px;
  }

  li {
    list-style: none;
    border-bottom: solid;
    border-width: thin;
    padding-bottom: 6px;
    padding-top: 6px;
    cursor: pointer;
  }
  
  li:hover {
    background-color: rgb(230, 230, 230);
  }
</style>